import { BehaviorSubject } from "rxjs";
import { COPILOT_STATE } from "../types/CommonTypes";

export const initialCopilotState: COPILOT_STATE = {
  isPanelOpen: false,
  messages: [],
  sessionId: null,
  isAwaitingResponse: false,
  pendingSuggestions: [],
  isHidden: false,
};

const copilotState$ = new BehaviorSubject<COPILOT_STATE>(initialCopilotState);

export default copilotState$;
